module.exports = __webpack_public_path__ + "static/img/spritely_logo.e4b3451.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-page/spritely_logo.svg
// module id = 9dE1
// module chunks = 1